import React, { useState, useMemo, useContext } from 'react'

import { useSelector } from 'react-redux'
import { Input, Tooltip } from 'antd'
import { isString } from 'lodash'

import { InstitutionContext } from '../../../../Providers/InstitutionProvider'
import { isCtrlKeyPressed } from '../../../../utils'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'

const { Search } = Input

const FIRST_OFFSET = 10
const BORDER_RADIUS = 10

const InstitutionSectionsList = ({ selected = [], onSelect }) => {
  const t = useSelector(selectTranslate)

  const { coloredSectionToYears } = useContext(InstitutionContext)

  const [search, setSearch] = useState('')
  const [selectedSections, setSelectedSections] = useState(selected ?? [])

  const filteredSectionToYears = useMemo(() => {
    const lowerCaseSearch = search.toLowerCase()

    return coloredSectionToYears.filter(sty =>
      sty.sectionName.toLowerCase().includes(lowerCaseSearch) || (isString(sty.sectionAbbreviation) && sty.sectionAbbreviation.toLowerCase().includes(lowerCaseSearch))
    )
  }, [coloredSectionToYears, search])

  const handleClick = (e, id) => {
    let sectionIds = []

    if (isCtrlKeyPressed(e)) {
      sectionIds = selectedSections.includes(id) ? selectedSections.filter(s => s !== id) : [...selectedSections, id]
    } else if (!selectedSections.includes(id) || selectedSections.length > 1) {
      sectionIds = [id]
    }

    setSelectedSections(sectionIds)
    onSelect(filteredSectionToYears.filter(s => sectionIds.some(id => s.id === id)))
  }

  const borderRadius = useMemo(() => `0px 0px ${BORDER_RADIUS}px ${BORDER_RADIUS}px`, [])

  return (
    <div style={{ height: '100%' }}>
      <h4><strong>{t('data_table.column_title.section')}</strong></h4>
      <div style={{ height: '100%' }}>
        <Search
          placeholder={t('filter.search')}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ maxWidth: '400px', zIndex: 2 }}
        />
        <div style={{ overflowY: 'scroll', maxHeight: '30em', borderRadius, transform: `translateY(-${FIRST_OFFSET}px)`, zIndex: 1 }}>
          {filteredSectionToYears.map((sty, i) => {
            const BORDER = selectedSections.includes(sty.id) ? `3px solid ${sty.color.border}` : 'none'

            return (
              <div
                key={sty.id}
                className='border rounded-lg p-3 shadow-sm cursor-pointer mb-2'
                style={{
                  backgroundColor: sty.color?.background,
                  color: sty.color?.border,
                  height: 40 + (i === 0 && FIRST_OFFSET) + 'px',
                  maxWidth: '400px',
                  borderLeft: BORDER,
                  borderRight: BORDER,
                  borderBottom: BORDER,
                  borderTop: selectedSections.includes(sty.id)
                    ? i === 0 ? FIRST_OFFSET + 3 + 'px solid' : `3px solid ${sty.color.border}`
                    : '',
                  borderRadius: (i === filteredSectionToYears.length - 1) && borderRadius,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  padding: `${10 + ((!selectedSections.includes(sty.id) && i === 0) && FIRST_OFFSET)}px 10px 10px 10px`,
                  overflow: 'hidden'
                }}
                onClick={(e) => handleClick(e, sty.id)}
              >
                <Tooltip title={sty.name} placement='right'>
                  <span
                    className='not-selectable-text'
                    style={{
                      color: sty.color?.text,
                      width: '100%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      textAlign: 'center',
                      fontSize: '14px',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical'
                    }}
                  >
                    {sty.name ?? `${sty.sectionAbbreviation} (${sty.schoolYearName})`}
                  </span>
                </Tooltip>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default InstitutionSectionsList
